/* 
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
import {
    Polymer,
    html
} from '@polymer/polymer/polymer-legacy.js';

/* import '../../paper-carousel/paper-carousel.js'; */
const template = html`
        <style include="app-styles">
            :host[dir] { content: "" }
            l2t-paper-slider{
				--paper-slide-height:250px;
                --paper-slide-dot:var(--disabled-black-color);
                --paper-slide-dot-selected:var(--primary-light-color);
				--paper-slider-dot-container-styles:{
                    left: 17%;
                    bottom :-3%
				}
            }
            .logoGradient {
                position: absolute;
                z-index: 1;
                width: 50%;
                background: linear-gradient(180deg, #3d2929, transparent);
                top:0px;
            }
            .logoStyle {
                width: 200px;
                padding-left: 40px;
                padding-top: 20px;
            }
            .carousel-spacing{                
                margin-left: 3%;
                max-height : 250px;
                
            }
            @media only screen and (min-width : 1000px) and (max-width : 1500px) {
                .widthsize {
                max-width: calc(100% - 16px) !important;
                }
            }
            @media only screen and (min-width : 900px) and (max-width : 1000px) {
                .widthsize {
                max-width: calc(90% - 16px) !important;
                }
            }
            @media only screen and (min-width : 840px) and (max-width : 900px) {
                .widthsize {
                max-width: calc(80% - 16px) !important;
                }
            }
            .breakword {
                white-space: initial;
            }
            .slideDot{
                --paper-slider-dot-container-styles:{
                        left: 40% !important;
                        bottom :-3%;                        
                    }
            } 
            
        </style>
       <app-media-query desktop="{{desktop}}" phone="{{phone}}" tablet="{{tablet}}"></app-media-query>
        <div class="content-wrapper mdl-grid mdl-grid--no-spacing full-height-desktop content-align-vertical-center full-height" phone$="{{phone}}" desktop$="{{desktop}}">
        <div class="content-wrapper mdl-grid mdl-grid--no-spacing full-height-desktop content-align-vertical-center full-height" phone$="{{phone}}" desktop$="{{desktop}}">
        <div class="mdl-cell--12-col logoGradient" role="img">
            <img alt="your bank logo" class="logoStyle" src="node_modules/sb_Registration_ui/images/YourBank_Logo.svg">
        </div>
            <template is="dom-if" if="{{showContent}}">
                <div class="carousel-spacing">
                    <l2t-paper-slider auto-progress slide-duration="3" infinite-loop class="slideDot mdl-cell--middle mdl-cell--11-col-desktop mdl-cell--1-offset-desktop " items="1" dotText="false" autoplay="true" controls="false">
                    <paper-slide>
                        <div class="widthsize mdl-cell--10-col-desktop">              
                            <div class="breakword primary-light-text-xxl  text-align-left">
                            <oe-i18n-msg msgid="h_welcome_to_your_bank"></oe-i18n-msg>
                            </div>                        
                            <div class="breakword primary-light-text-l text-align-left ">
                                <oe-i18n-msg msgid="m_bankingReimagined"></oe-i18n-msg>
                            </div>
                        </div>
                    </paper-slide>
                    <paper-slide>
                        <div class="widthsize mdl-cell--10-col-desktop">
                            <div class="breakword primary-light-text-xxl  text-align-left">
                            <oe-i18n-msg msgid="h_itsHere"></oe-i18n-msg>
                            </div>
                            <div class="breakword primary-light-text-l text-align-left ">
                                <oe-i18n-msg msgid="m_checkOutNewInternetBanking"></oe-i18n-msg>
                            </div>
                            
                        </div>
                    </paper-slide>
                    <paper-slide>
                        <div class="widthsize mdl-cell--10-col-desktop">
                            <div class="breakword primary-light-text-xxl  text-align-left">
                                <oe-i18n-msg msgid="h_BusinessBankingWith"></oe-i18n-msg>                                                                
                                <oe-i18n-msg msgid="h_PowerofImagination"></oe-i18n-msg>                                
                            </div>
                            <div class="breakword primary-light-text-l text-align-left ">
                                <oe-i18n-msg msgid="m_ManageyourBusinessEffectivelyInaDigitalWorld"></oe-i18n-msg>
                            </div>
                            
                        </div>
                    </paper-slide>
                    <paper-slide>
                        <div class="widthsize mdl-cell--10-col-desktop">
                            <div class="breakword primary-light-text-xxl  text-align-left">
                            <oe-i18n-msg msgid="h_YouAreOurFocus"></oe-i18n-msg>
                            </div>
                            <div class="breakword primary-light-text-l text-align-left ">
                                <oe-i18n-msg msgid="m_EnjoyaPersonalizedAndContextualizedExperience"></oe-i18n-msg>
                            </div>
                            
                        </div>
                    </paper-slide>
                    </l2t-paper-slider>
                </div>
            </template>

            <template is="dom-if" if="{{!showContent}}">
            <div class="carousel-spacing">
                <l2t-paper-slider auto-progress slide-duration="3" infinite-loop class="mdl-cell--middle mdl-cell--11-col-desktop mdl-cell--2-col-desktop mdl-cell--1-offset-desktop " items="1" dotText="false" autoplay="true" controls="false">
                    <paper-slide>
                        <div class="widthsize mdl-cell--6-col-desktop">              
                            <div class="font-weight-light primary-light-text-xxxl  text-align-left">
                                <oe-i18n-msg msgid="h_WhyFinacle"></oe-i18n-msg>
                            </div>
                            <div class="mdl-cell mdl-grid"></div>
                            <!--div class=" mdl-grid"></div-->
                            
                            <div class="breakword widthsize  primary-light-text-m text-align-left margin-l-zero">
                            lorem ipsum dolor sit amet consectetur adipiscing elit lorem ipsum lorem ipsum dolor
                            </div>
                            <div class=" mdl-grid"></div>
							<div class="breakword widthsize primary-light-text-m text-align-left margin-l-zero">
							lorem ipsum dolor sit amet consectetur
							</div>
                            <div class=" mdl-grid"></div>
							<div class="breakword widthsize  primary-light-text-m text-align-left margin-l-zero">
							lorem ipsum dolor sit amet consectetur adipiscing elit lorem ipsum 
							</div>
                            
                            <div class="mdl-cell mdl-grid"></div>
                            <div class=" mdl-grid"></div>
                        </div>
                    </paper-slide>
                    <paper-slide>
                        <div class="widthsize mdl-cell--6-col-desktop">              
                            <div class="font-weight-light primary-light-text-xxxl  text-align-left">
                                <oe-i18n-msg msgid="h_WhyFinacle"></oe-i18n-msg>
                            </div>
                            <div class="mdl-cell mdl-grid"></div>
                            <!--div class=" mdl-grid"></div-->
                            
                            <div class="breakword widthsize  primary-light-text-m text-align-left margin-l-zero">
                            lorem ipsum dolor sit amet consectetur adipiscing elit lorem ipsum lorem ipsum dolor
                            </div>
                            <div class=" mdl-grid"></div>
							<div class="breakword widthsize primary-light-text-m text-align-left margin-l-zero">
							lorem ipsum dolor sit amet consectetur
							</div>
                            <div class=" mdl-grid"></div>
							<div class="breakword widthsize  primary-light-text-m text-align-left margin-l-zero">
							lorem ipsum dolor sit amet consectetur adipiscing elit lorem ipsum 
							</div>
                            
                            <div class="mdl-cell mdl-grid"></div>
                            <div class=" mdl-grid"></div>
                        </div>
                    </paper-slide>
                    <paper-slide>
                        <div class="widthsize mdl-cell--6-col-desktop">              
                            <div class="font-weight-light primary-light-text-xxxl  text-align-left">
                                <oe-i18n-msg msgid="h_WhyFinacle"></oe-i18n-msg>
                            </div>
                            <div class="mdl-cell mdl-grid"></div>
                            <!--div class=" mdl-grid"></div-->
                            
                            <div class="breakword widthsize  primary-light-text-m text-align-left margin-l-zero">
                            lorem ipsum dolor sit amet consectetur adipiscing elit lorem ipsum lorem ipsum dolor
                            </div>
                            <div class=" mdl-grid"></div>
							<div class="breakword widthsize primary-light-text-m text-align-left margin-l-zero">
							lorem ipsum dolor sit amet consectetur
							</div>
                            <div class=" mdl-grid"></div>
							<div class="breakword widthsize  primary-light-text-m text-align-left margin-l-zero">
							lorem ipsum dolor sit amet consectetur adipiscing elit lorem ipsum 
							</div>
                            
                            <div class="mdl-cell mdl-grid"></div>
                            <div class=" mdl-grid"></div>
                        </div>
                    </paper-slide>
                    <paper-slide>
                        <div class="widthsize mdl-cell--6-col-desktop">              
                            <div class="font-weight-light primary-light-text-xxxl  text-align-left">
                                <oe-i18n-msg msgid="h_WhyFinacle"></oe-i18n-msg>
                            </div>
                            <div class="mdl-cell mdl-grid"></div>
                            <!--div class=" mdl-grid"></div-->
                            
                            <div class="breakword widthsize  primary-light-text-m text-align-left margin-l-zero">
                            lorem ipsum dolor sit amet consectetur adipiscing elit lorem ipsum lorem ipsum dolor
                            </div>
                            <div class=" mdl-grid"></div>
							<div class="breakword widthsize primary-light-text-m text-align-left margin-l-zero">
							lorem ipsum dolor sit amet consectetur
							</div>
                            <div class=" mdl-grid"></div>
							<div class="breakword widthsize  primary-light-text-m text-align-left margin-l-zero">
							lorem ipsum dolor sit amet consectetur adipiscing elit lorem ipsum 
							</div>
                            
                            <div class="mdl-cell mdl-grid"></div>
                            <div class=" mdl-grid"></div>
                        </div>
                    </paper-slide>
                </l2t-paper-slider>
                </div>
            </template>
        </div>`;
Polymer({
    is: 'reg-carousel',
    _template: template,
    properties: {
        page: {
            type: String,
            notify: true,
            observer: "show"
        }
    },
    show: function () {
        if (this.page == "0" || this.page == "1" || this.page == "4" || this.page == "5" || this.page == "6" || this.page == "8" || this.page == "9" || this.page == "10" || this.page == "11")
            this.showContent = true
        else
            this.showContent = false
    }
});
